<template>
<div class="dash-cont" style="" >
<h1 class='white text'><!-- Dashboard --></h1>

<br><br><br><br>

<div class="ui inverted small statistics" style='justify-content: center'>
  <div class="red inverted statistic">
    <div class="label">unchecked</div>
    <div class="value">
        <i class="exclamation icon"></i> {{stats.alerts}}
    </div>
    <div class="label">
       Alerts
    </div>
  </div>

  <div class="orange inverted statistic">
    <div class="label">unchecked</div>
    <div class="value">
      <i class="exclamation icon"></i> {{stats.warnings}}
    </div>
    <div class="label">
      Warnings
    </div>
  </div>

  <div class="purple inverted statistic">
    <div class="label">in</div>
    <div class="value">
      {{stats.productsWithIssues}}
    </div>
    <div class="label">
      Products
    </div>
  </div>

  <div class="green inverted statistic">
    <div class="label">Of</div>
     <div class="value">
      {{stats.totalProducts}}
    </div>
    <div class="label">
      total
    </div>
  </div>
</div>


<!-- syncing notification -->
<div v-if="$root.authCompleted&&$parent.$parent.onboarding.syncing&&$root.secondsSinceFirstSellerAccountCreated<9999" data-onboarding="syncing" class="ui icon message" style="text-shadow:none;">
  <i class="notched circle loading icon"></i>
  <i class="close icon" @click.stop.prevent="$parent.$parent.onboarder('syncing')"></i>
  <div class="content">
    <p>
      Hi there and welcome! Things are still syncing up, but you can already get started.
    </p>
    <p>
      In a few hours all modules will be fully on-line.
    </p>
  </div>
</div>


<!-- email confirm notification -->
<div v-if="emailConfirmReminder.length>0" class="ui icon message" style="text-shadow:none;">
  <i class="mail outline icon"></i>
  <div class="content">
    <p>Check your inbox and confirm
      <strong v-for="email, index in emailConfirmReminder"><span v-show="index>0">,</span> {{email}}</strong>.
      <br />
    <small>It is also a good idea to whilelist @SentryKit.com e-mail addresses.</small></p>
  </div>
</div>


<!-- account notifications -->
<div v-if="$root.paymentStatus==402" class="ui negative message" style="text-shadow:none;">
  <div class="header">
    Your SentryKit account is unfortunately suspended.
  </div>
  <p>We really tried but couldn't charge you for the current running month.</p>
  <p>Please add a payment method in your <router-link to="/settings">Account Settings</router-link> and get in touch with Support to continue using the service.</p>
</div>
<div v-if="$root.paymentStatus==99402" class="ui negative message" style="text-shadow:none;">
  <div class="header">
    Your SentryKit account is currently suspended.
  </div>
  <p>Sorry, but after multiple attempts we still couldn't charge you for the current month.</p>
  <p>Please add a payment method in your <router-link to="/settings">Account Settings</router-link> then get in touch with Support to continue using the service.</p>
</div>

<div v-if="$root.paymentStatus==403" class="ui negative message" style="text-shadow:none;">
  <div class="header">
    Your SentryKit account is currently suspended.
  </div>
  <p>Sorry, it seems your payment plan has been cancelled.</p>
  <p>Please add a payment method in your <router-link to="/settings">Account Settings</router-link> then get in touch with Support to continue using the service.</p>
</div>

<div v-if="$root.paymentStatus==3" class="ui negative message" style="text-shadow:none;">
  <div class="header">
    Payment Failed
  </div>
  <p>Your payment for this running month of your SentryKit subscription failed.</p>
  <p>No worries, we get it that this can happen. We left everything running for you but you are now running on credit.</p>
  <p>Please add or change the payment method in your <router-link to="/settings">Account Settings</router-link> to continue using the service distruption free.</p>
</div>

</div>
</template>

<script>
export default {
  data: function () {
    return {
      stats: {
        alerts: 0,
        warnings: 0,
        productsWithIssues: 0,
        totalProducts: 0,
      },
      emailConfirmReminder: [],
      apiStats: null,
    }
  },
  methods: {
    calcStats: function (worldStore) {
      const alerts = new Set()
      const warnings = new Set()
      const productsWithIssues = new Set()

      // Handle flat watchDogs structure (e.g., "inventory_123", "keyword_456")
      const watchDogKeys = Object.keys(worldStore.watchDogs || {})
      for (let i = 0; i < watchDogKeys.length; ++i) {
        const fullKey = watchDogKeys[i]
        const watchDog = worldStore.watchDogs[fullKey]
        const watchDogName = fullKey.split('_')[0]

        if (watchDog.status === 20 || watchDog.status === 21) continue

        // With flat structure, each watchDog IS an item
        if (watchDog.hasOwnProperty('issueStatus') && watchDog.issueStatus === 0 && !watchDog.muted) {
          if (watchDog.status === 1 || watchDog.status === 2) {
            const set = watchDog.status === 1 ? warnings : alerts
            if (watchDog.productGroupId) {
              set.add(watchDogName + '-' + watchDog.productGroupId)
              productsWithIssues.add(watchDog.productGroupId)
            } else if (watchDog.productId) {
              set.add(watchDogName + '-' + watchDog.productId)
              productsWithIssues.add(watchDog.productId)
            }
          }
        }
      }

      return {
        alerts: alerts.size,
        warnings: warnings.size,
        productsWithIssues: productsWithIssues.size,
        totalProducts: Object.keys(worldStore.products || {}).length,
      }
    },
    updateStatsFromAPI: function (apiStats) {
      console.log('[Dashboard] updateStatsFromAPI called with:', apiStats)
      this.apiStats = apiStats
      this.stats = apiStats
    },
    resetStats: function () {
      console.log('[Dashboard] resetStats called - clearing old data')
      this.apiStats = null
      this.stats = { alerts: 0, warnings: 0, productsWithIssues: 0, totalProducts: 0 }
    },
    calcEmailConfirmReminder: function (worldStore) {
      if (Array.isArray(worldStore.unverifiedEmailAddresses)) {
        return worldStore.unverifiedEmailAddresses
      } else {
        return []
      }
    },
  },
  watch: {
    '$parent.$parent.worldStore': function (worldStore) {
      // Only calculate stats if we don't have API stats
      if (!this.apiStats) {
        this.stats = this.calcStats(worldStore)
      }
      this.emailConfirmReminder = this.calcEmailConfirmReminder(worldStore)
    }
  },
  created: function () {
    if (this.$parent.$parent.worldStore) {
      // Only calculate stats if we don't have API stats
      if (!this.apiStats) {
        this.stats = this.calcStats(this.$parent.$parent.worldStore)
      }
      this.emailConfirmReminder = this.calcEmailConfirmReminder(this.$parent.$parent.worldStore)
    }

    // Listen for pre-loaded stats from main.js
    this.$root.$on('dashboard-stats-loaded', (stats) => {
      console.log('[Dashboard] Received pre-loaded stats:', stats)
      this.updateStatsFromAPI(stats)
    })

    // Check if stats are already available from main.js
    if (this.$root.dashboardStats) {
      console.log('[Dashboard] Using pre-loaded stats from main.js')
      this.updateStatsFromAPI(this.$root.dashboardStats)
    }
  },
}
</script>

<style>
#homeWrap .dash-cont {color:#fff;}

.dash-cont {
  margin: 0 auto;
  position: relative;
  width: 600px;
  height:300px;
  top:50%;
  margin-bottom:-300px;
  -webkit-transform: translateY(-60%);
  transform: translateY(-60%);
  -webkit-transition-property: opacity transform;
  transition-property: opacity transform;
  -webkit-transition-duration: 0.5s;
  transition-duration: 0.5s;
}


</style>



// WEBPACK FOOTER //
// Dashboard.vue?f632b6e0